import type {Recipe} from './types';

export const crocchetteDiPatateEProsciutto: Recipe = {
    id: 18,
    key: "crocchetteDiPatateEProsciutto",
    pictures: [
        {index: 0, url: "https://blog.giallozafferano.it/ricettiamoconmary/wp-content/uploads/2020/06/IMG_9603-960x627.jpg"},
    ],
    i18n: {
        IT: {
            title: "Crocchette di Patate e Prosciutto",
            servings: "4 persone",
            ingredients: [
                "600 g di patate",
                "2 uova (1 per l'impasto e 1 per impanare)",
                "½ hg di prosciutto cotto",
                "Parmigiano",
                "Noce moscata",
                "Pangrattato (quanto basta)",
                "Prezzemolo (va bene anche essiccato)",
                "Sale",
            ],
            steps: [
                "Lessare in acqua salata le patate pelate, scolarle bene e schiacciarle con una forchetta in una terrina.",
                "Aggiungere il prosciutto tritato molto fine, la noce moscata, il parmigiano e il prezzemolo. Assaggiare e aggiustare il sale.",
                "Aggiungere l'uovo e impastare bene con una forchetta.",
                "Aggiungere pangrattato amalgamando bene finché l'impasto non sia troppo tenero.",
                "Sbattere il secondo uovo con un po' di latte e salarlo.",
                "Con l'impasto di patate formare con le mani dei cilindretti di 2,5-3 cm di diametro e lunghi 6-7 cm. Passarli velocemente nell'uovo sbattuto poi nel pangrattato rotolandoli e premendo affinché il pangrattato si attacchi bene. Schiacciare e impanare bene anche le estremità.",
                "Quando tutte le crocchette sono pronte, passarle una seconda volta nell'uovo e pangrattato.",
                "Mettere in una padella ampia abbondante olio di semi e friggere le crocchette rigirandole delicatamente di tanto in tanto finché non abbiano un bel colore dorato (si possono usare due cucchiai facendo attenzione che non si rompano). Scolare su carta assorbente.",
                "Se si preparano prima, conviene riscaldarle in forno prima di consumarle.",
            ],
            notes: "Contorni consigliati: Patate lesse condite con olio d’oliva e origano.",
        },
        EN: {
            title: "Potato and Ham Croquettes",
            servings: "4 servings",
            ingredients: [
                "600 g of potatoes",
                "2 eggs (1 for the mixture and 1 for breading)",
                "50 g of cooked ham",
                "Parmesan cheese",
                "Nutmeg",
                "Breadcrumbs (as needed)",
                "Parsley (dried is fine)",
                "Salt",
            ],
            steps: [
                "Boil the peeled potatoes in salted water, drain them well, and mash them with a fork in a bowl.",
                "Add the finely chopped ham, nutmeg, Parmesan cheese, and parsley. Taste and adjust the salt.",
                "Add the egg and mix well with a fork.",
                "Add breadcrumbs, mixing well until the mixture is no longer too soft.",
                "Beat the second egg with a little milk and salt it.",
                "With the potato mixture, form cylinders with your hands, 2.5-3 cm in diameter and 6-7 cm long. Quickly roll them in the beaten egg, then in breadcrumbs, rolling and pressing to ensure the breadcrumbs stick well. Also, bread the ends well.",
                "When all the croquettes are ready, pass them a second time in the egg and breadcrumbs.",
                "In a large pan, heat plenty of vegetable oil and fry the croquettes, turning them gently from time to time until they have a nice golden color (you can use two spoons, being careful not to break them). Drain on paper towels.",
                "If prepared in advance, it's best to reheat them in the oven before serving.",
            ],
            notes: "Recommended sides: Boiled potatoes seasoned with olive oil and oregano.",
        },
        PL: {
            title: "Krokiety ziemniaczane z szynką",
            servings: "4 porcje",
            ingredients: [
                "600 g ziemniaków",
                "2 jajka (1 do masy i 1 do panierki)",
                "50 g gotowanej szynki",
                "Ser parmezan",
                "Gałka muszkatołowa",
                "Bułka tarta (w razie potrzeby)",
                "Pietruszka (może być suszona)",
                "Sól",
            ],
            steps: [
                "Ugotuj obrane ziemniaki w osolonej wodzie, dobrze je odcedź i rozgnieć widelcem w misce.",
                "Dodaj drobno posiekaną szynkę, gałkę muszkatołową, ser parmezan i pietruszkę. Spróbuj i dopraw solą.",
                "Dodaj jajko i dobrze wymieszaj widelcem.",
                "Dodaj bułkę tartą, dobrze mieszając, aż masa przestanie być zbyt miękka.",
                "Rozbij drugie jajko z odrobiną mleka i posól je.",
                "Z masy ziemniaczanej formuj cylindry o średnicy 2,5-3 cm i długości 6-7 cm. Szybko obtocz je w roztrzepanym jajku, a następnie w bułce tartej, rolując i dociskając, aby bułka tarta dobrze się przykleiła. Dobrze obtocz także końce.",
                "Kiedy wszystkie krokiety są gotowe, obtocz je ponownie w jajku i bułce tartej.",
                "W dużej patelni rozgrzej dużą ilość oleju roślinnego i smaż krokiety, delikatnie je obracając od czasu do czasu, aż uzyskają ładny złoty kolor (można użyć dwóch łyżek, uważając, aby się nie rozpadły). Odsącz na papierowych ręcznikach.",
                "Jeśli przygotowane wcześniej, najlepiej podgrzać je w piekarniku przed podaniem.",
            ],
            notes: "Zalecane dodatki: Gotowane ziemniaki z oliwą z oliwek i oregano.",
        },
    },
};
